/*
  based on: https://github.com/rzeigler/waveguide/blob/master/src/ref.ts
 */
import * as T from "./effect";
/**
 * Creates an IO that will allocate a Ref.
 * Curried form of makeRef_ to allow for inference on the initial type
 */
export const makeRef = (initial) => T.sync(() => {
    let value = initial;
    const get = T.sync(() => value);
    const set = (a) => T.sync(() => {
        const prev = value;
        value = a;
        return prev;
    });
    const update = (f) => T.sync(() => (value = f(value)));
    const modify = (f) => T.sync(() => {
        const [b, a] = f(value);
        value = a;
        return b;
    });
    return {
        get,
        set,
        update,
        modify
    };
});
